import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core";
import clsx from 'clsx';
import ISelectItem from "./types/ISelectItem";
import GroupStatusEnum from "./enums/GroupStatusEnum";
import { calcgroupStatusState } from "./groupedItemHelpers"
import IdleTimer from "react-idle-timer";

const useStylesPopUp = makeStyles({
    locationNameBlock: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        color: "#14191C",
        fontWeight: 400,
        fontSize: 19,
        height: 48
    },

});

const useStylesCheckBox = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: 3,
        width: 15,
        height: 15,
        backgroundColor: '#ECECEC'
    },
    checkedIcon: {
        backgroundColor: '#ECECEC',
        '&:before': {
            display: 'block',
            width: 15,
            height: 15,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%2303090E'/%3E%3C/svg%3E\")",
            content: '""',
        }
    },
    checkboxInput: {
        '&.MuiCheckbox-root': {
            '&:not(.Mui-checked) .MuiIconButton-label:after': {
                backgroundColor: "#EFF0F2",
            },
            '& .MuiIconButton-label svg.MuiSvgIcon-root': {
                fill: "#EFF0F2",
            },
            '&.whiteBg': {
                '&:not(.Mui-checked) .MuiIconButton-label:after': {
                    backgroundColor: "#FFFFFF",
                },
                '& .MuiIconButton-label svg.MuiSvgIcon-root': {
                    fill: "#FFFFFF",
                },
            },
        },
    },
    locationCheckbox: {
        // width: 'calc(100% - 30px)',
        marginLeft: 30,
        paddingBottom: 12
    },
    removeIcon: {
        backgroundColor: '#ECECEC',
        '&:before': {
            display: 'block',
            width: 15,
            height: 15,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M19 9H2v-2h12v2z' fill='%2303090E'/%3E%3C/svg%3E\")",
            content: '""',
        }
    },

});

const CheckBoxElement = (props: CheckboxProps): JSX.Element => {
    const classes = useStylesCheckBox();
    return (
        <Checkbox
            className={clsx(classes.root, classes.checkboxInput)}
           // disableRipple
          //  color="default"
           // checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
           // icon={<span className={classes.icon} />}
           // inputProps={{ 'aria-label': 'decorative checkbox' }}
            {...props}
        />
    );
}

const CheckBoxGroup = (props: CheckboxProps): JSX.Element => {
    const classes = useStylesCheckBox();
    return (
        <Checkbox
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            indeterminateIcon={<span className={clsx(classes.icon, classes.removeIcon)} />}
            icon={<span className={classes.icon} />}
            inputProps={{ 'aria-label': 'decorative checkbox' }}
            {...props}
        />
    );
}

const createStyledCheckbox = (currentItem: ISelectItem) => {
    // if (currentItem.isGroup) {
    //     return <CheckBoxGroup
    //         indeterminate={currentItem.groupStatus === GroupStatusEnum.Mixed}
    //         checked={currentItem.groupStatus !== GroupStatusEnum.NoneSelected}
    //     />;
    // } else {


        return <CheckBoxElement
            checked={currentItem.selected ?? false}
        />;
   // }
}

const CustomerPopup = ({ popState, customerState, filterCustomer }: any): JSX.Element => {
    const classes = useStylesPopUp();
    const [searchText, setSearchText] = React.useState("");
    const setcustomerState = customerState[1];

    const onClickGroup = (currentItem: ISelectItem) => setcustomerState((previousState: ISelectItem[]) => {
        const groupIndex = previousState.findIndex(el => el.value === currentItem.value && el.isGroup);
        const oldGroup = previousState[groupIndex];
        const newGroup = { ...oldGroup };
        if (oldGroup.groupStatus === GroupStatusEnum.NoneSelected) {
            newGroup.groupStatus = GroupStatusEnum.AllSelected;
        } else {
            newGroup.groupStatus = GroupStatusEnum.NoneSelected;
        }

        const newLocationState =
            previousState.map((item: ISelectItem) => {
                if (item.groupId === currentItem.value && !item.isGroup) {
                    return { ...item, selected: newGroup.groupStatus === GroupStatusEnum.AllSelected };
                } else {
                    return item;
                }
            });

        newLocationState[groupIndex] = newGroup;
        return newLocationState;
    }
    );

    const onClickElement = (currentItem: ISelectItem) => setcustomerState((previousState: ISelectItem[]) => {
        const newLocationState =
            previousState.map((item: ISelectItem) => {
                if (item.value === currentItem.value) {
                    return { ...item, selected: !item.selected };
                } else {
                    return item;
                }
            });
        // const newgroupStatusState = calcgroupStatusState(
        //     newLocationState.filter(q => currentItem.groupId === q.groupId && !q.isGroup)
        // );

        // const groupIndex = previousState.findIndex(el => el.value === currentItem.groupId && el.isGroup);
        // const oldGroup = previousState[groupIndex];
        // if (oldGroup.groupStatus !== newgroupStatusState) {
        //     newLocationState[groupIndex] = { ...oldGroup, groupStatus: newgroupStatusState };
        // }
        return newLocationState;
    }
    );

    return (
        <Dialog open={popState[0]} PaperProps={{
            style: {
                backgroundColor: '#FFF'
            },
        }} onClose={() => popState[1](false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth="sm"
        >
            <DialogContent
                style={{
                    display: "flex", justifyContent: "center", flexDirection: "column", marginBottom: 15, overflow: "hidden"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <Typography
                        style={{ color: "#14191C", fontWeight: 400, fontSize: 19 }}
                        gutterBottom
                    >
                        Choose Customer
                    </Typography>
                    <IconButton onClick={() => popState[1](false)} aria-label="close">
                        <CloseIcon style={{ color: "#000" }} />
                    </IconButton>
                </div>
                <TextField
                    id="filled-start-adornment"
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon style={{ color: "#707070" }} />
                            </InputAdornment>
                        ),
                        style: { backgroundColor: "#ECECEC", color: "#333" }
                    }}
                    variant="outlined"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    autoComplete="off"
                />
            </DialogContent>
            <div style={{ height: 1, backgroundColor: "#979797" }}></div>
            <DialogContent
                style={{
                    display: "flex", justifyContent: "center", flexDirection: "column"
                }}
            >
                <div
                    style={{
                        display: "box", height: 300, flexDirection: "column"
                    }}
                >
                    {customerState[0].map((item: ISelectItem) => {
                        if (searchText == "" || (item.text?.indexOf(searchText) != undefined && item.text?.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)) {
                            return (
                                <Typography key={item.value} variant="h6"
                                    className={classes.locationNameBlock}
                                    onClick={() => {  onClickElement(item) }}>
                                    {createStyledCheckbox(item)}
                                    {item.text}
                                </Typography>
                            );

                        } else {
                            return null;
                        }
                    })}
                </div>
            </DialogContent>
            <div style={{ height: 1, backgroundColor: "#979797" }}></div>
            <DialogContent
                style={{
                    display: "flex", justifyContent: "center", flexDirection: "column", overflow: "hidden"
                }}
            >
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 15, marginTop: 15 }} >
                    <Button
                        style={{
                            width: 163, height: 44, background: "#ECECEC", color: "#03090E", textTransform: "none", fontWeight: 700, fontSize: 19
                        }}
                        variant="contained"
                        color="primary"
                        disableElevation
                        onClick={() => popState[1](false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        style={{ width: 163, height: 44, background: "#02489D", textTransform: "none", fontWeight: 700, fontSize: 19 }}
                        variant="contained"
                        color="primary"
                        disableElevation
                        onClick={() => {
                            popState[1](false);
                            filterCustomer();
                        }}
                    >
                        Apply
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default CustomerPopup;